import { AnyTag, PerspectiveTag, Tag } from '../../state/types';

export const ALL = 'all';

export const TAGS: {
  value: AnyTag;
  text: string;
}[] = [
  { value: ALL, text: 'All' },
  { value: Tag.APPEAL, text: 'Appeals' },
  { value: Tag.APPEAL_REPORTER, text: 'Appeals(Reporter)' },
  { value: Tag.STRICT_ARTICLE, text: 'Strict Article' },
  { value: PerspectiveTag.ATTACK_ON_AUTHOR, text: 'Attack On Author' },
  { value: PerspectiveTag.ATTACK_ON_COMMENTER, text: 'Attack On Commenter' },
  { value: Tag.BLACKLISTED_IP, text: 'Blocked IP' },
  { value: Tag.BLACKLISTED_USER, text: 'Blocked User' },
  { value: Tag.EMOJIS, text: 'Emojis' },
  { value: Tag.EXTERNAL_LINK, text: 'External Link' },
  { value: PerspectiveTag.FLIRTATION, text: 'Flirtation' },
  { value: Tag.ANIMATION, text: 'GIF' },
  { value: PerspectiveTag.IDENTITY_ATTACK, text: 'Identity Attack' },
  { value: Tag.IMAGE, text: 'Image' },
  { value: Tag.OPENWEB_INCIVILITY, text: 'Incivility' },
  { value: PerspectiveTag.INCOHERENT, text: 'Incoherent' },
  { value: PerspectiveTag.INFLAMMATORY, text: 'Inflammatory' },
  { value: PerspectiveTag.INSULT, text: 'Insult' },
  { value: Tag.INVALID_CHARACTERS, text: 'Invalid Characters' },
  { value: PerspectiveTag.LIKELY_TO_REJECT, text: 'Likely To Reject' },
  { value: Tag.MALICIOUS, text: 'Malicious' },
  { value: Tag.MANUAL, text: 'Manual' },
  { value: PerspectiveTag.OBSCENE, text: 'Obscene' },
  { value: Tag.PORN_LINK, text: 'Porn' },
  { value: PerspectiveTag.PROFANITY, text: 'Profanity' },
  { value: Tag.DUPLICATION, text: 'Repeated' },
  { value: Tag.REPORTED, text: 'Reported' },
  { value: Tag.RESTRICTED_LANGUAGE, text: 'Restricted Language' },
  { value: Tag.RESTRICTED_WORDS, text: 'Restricted Word' },
  { value: PerspectiveTag.SEVERE_TOXICITY, text: 'Severe Toxicity' },
  { value: PerspectiveTag.SEXUALLY_EXPLICIT, text: 'Sexually Explicit' },
  { value: Tag.STAFF_REPORT, text: 'Staff Report' },
  { value: Tag.SPAM, text: 'Suspected Spam' },
  { value: Tag.OPENWEB_OVERTURN_MODEL, text: 'Suspected Unsafe' },
  { value: PerspectiveTag.THREAT, text: 'Threat' },
  { value: PerspectiveTag.TOXICITY, text: 'Toxicity' },
  { value: PerspectiveTag.UNSUBSTANTIAL, text: 'Unsubstantial' },
  { value: Tag.UPPERCASE, text: 'Uppercase' },
  { value: Tag.USER_INCIVILITY_HIGH, text: 'User Incivility High' },
  { value: Tag.USER_INCIVILITY_MEDIUM, text: 'User Incivility Medium' },
  { value: Tag.VIDEO, text: 'Video' },
  { value: Tag.SUSPECTED_BOT, text: 'Suspected Bot' },
  { value: Tag.AI_MODERATED, text: 'AI Moderation Assist' },
  { value: Tag.HIDDEN_CHARACTERS, text: 'Invisible Character' },
  { value: Tag.DOXXING, text: 'Personal Information' },
  { value: Tag.SUSPENDED, text: 'Auto-suspended' }
];
